
<template>
    <div>
        <h1 class="page-title">{{ title }}</h1>
    </div>
    <div class="flex justify-end">
        <Button
            label="Ajouter une catégorie"
            @click="router.push({ name: 'addCategory' })"
            icon="pi pi-plus"
            class="button-add"
        />
    </div>
    

    <div class="card">
        <DataTable
            :value="tableData"
            :rows="rows"
            :totalRecords="totalRecords"
            :currentPage="currentPage"
            :rowHover="true"
            :loading="loading"
            :rowsPerPageOptions="[10, 25, 100]"
            lazy
            paginator
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} entrées"
            @page="onPaginate"
            @rowReorder="onRowReorder($event)"
            @sort="onSort($event)"
            removableSort
        >
            <template #header>
                <div class="flex justify-between card-header border-0 ">
                    <div class="card-title">
                        <div class="my-1">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText type="text" class="form-control w-[250px] ps-15"
                                    v-model="criteria"
                                    @keyup.enter="onFilterDt"
                                    placeholder="Rechercher une catégorie"
                                    @input="onClearInputFilter" />
                            </span>
                        </div>
                    </div>
                    <div class="card-toolbar">
                        <div data-kt-customer-table-toolbar="base">
                            <router-link v-if="uuidRouteParam" :to="{ name: 'addCategory', params: { uuid: uuidRouteParam } }">
                                <button type="button" class="btn btn-primary">
                                    <span class="svg-icon svg-icon-2">
                                        <inline-svg src="media/icons/duotune/arrows/arr075.svg" />
                                    </span>
                                    Ajouter une sous-catégorie
                                </button>
                            </router-link>
                            
                        </div>
                    </div>
                </div>
            </template>
            <div class="card-body pt-0">
                <Column :rowReorder="true" headerStyle="width: 3rem" :reorderableColumn="false" />
                <Column v-if="!uuidRouteParam" field="vignette" header="Miniature">
                    <template #body="slotProps">
                        <img v-if="slotProps.data.vignette" :src="slotProps.data.vignette.url" class="w-14" />
                    </template>
                </Column>
                <Column field="name" header="Nom de la catégorie"></Column>
                <Column field="enabled" header="Statut">
                    <template #body="slotProps">
                        <div v-if="slotProps.data.enabled" class="badge border-white text-green-800 bg-green-200 p-4">Activé</div>
                        <div v-else class="badge border-white text-red-800 bg-red-200 p-4">Désactivé</div>
                    </template>
                </Column>
                <Column field="position" header="Position">
                    <template #body="slotProps">
                        <span> {{ slotProps.data.position }} </span>
                    </template>
                </Column>
                <Column headerStyle="width: 12em;" class="whitespace-nowrap">
                    <template #header>
                        <div>Actions</div>
                    </template>
                    <template #body="slotProps">
                        <router-link :to="{ name: 'editCategory', params: { uuid: slotProps.data.uuid }}">
                            <Button type="button" icon="pi pi-pencil " title="Éditer" class="p-edition" style="margin-right: 0.5em"></Button>
                        </router-link>
                        <Button @click="checkArchiveCategory(slotProps.data)" type="button" title="Supprimer" icon="pi pi-trash" class="p-button-danger"></Button>
                        <a v-if="slotProps.data.hasChildren" :href="$router.resolve({name:'listCategories', params: {uuid: slotProps.data.uuid}}).href">
                            <Button type="button" icon="pi pi-eye" title="Voir les sous-catégories" class="p-button-success p-button-eye ml-2"></Button>
                        </a>
                    </template>
                </Column>
            </div>
            <template #empty>Aucun résultat trouvé.</template>
        </DataTable>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { useRoute } from "vue-router";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import {
    fetchCategory,
    fetchPaginatedCategories,
    getCategoryParentUuid
} from "@/_services/category/category";
import { ICategory } from "@/models/category/ICategory";
import router from "@/router";

const route = useRoute();
const loading = ref<boolean>(true);
const categories: ICategory[] = [];
const tableData = ref<Array<ICategory>>(categories);
const uuidRouteParam = ref<string | null>(null);
const parents = ref(Array<object>());
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const modeSortable = ref<boolean>(false);
const categoryLabel = ref<string>("");
const title = ref<string>("Gérer les catégories");

onMounted(async () => {
    uuidRouteParam.value = route.params.uuid as string;
    categoryLabel.value = uuidRouteParam.value ? "sous-catégorie" : "catégorie";
    await populateDatatable(rows.value, page.value);
    if (uuidRouteParam.value) {
        let name = await getParentsCategory(tableData.value[0]);
        title.value = `Sous-catégories de ${name}`;
        /*
        setCurrentPageBreadcrumbs(`Sous-catégories de ${tableData.value[0].name}`, parents.value);*/
    } else {
        /*setCurrentPageBreadcrumbs(uuidRouteParam.value ? "Sous-catégorie" : "Catégorie", [
            {
                label: "Arborescence de catégories",
                link: { name: "apps-categories-treeview" },
            },
        ]);*/
    }
});

const getParentsCategory = async (category: ICategory) => {
  let parentUuid = getCategoryParentUuid(category);
  if (null !== parentUuid) {
    let parent = await fetchCategory(parentUuid);
    return parent.name;
  }
  return '';
}
const getParentsForBreadcrumb = async (category: ICategory) => {
    let parentUuid = getCategoryParentUuid(category);
    if (null !== parentUuid) {
        let parent = await fetchCategory(parentUuid);
        if (parent.lvl === 0) {
            parents.value.reverse();
            parents.value.unshift({
                label: "Catégories",
                link: { name: "listCategories" },
            });
            return;
        }
        parents.value.push({ label: parent.name, link: parent.uuid });
        getParentsForBreadcrumb(parent);
    }
};

const onFilterDt = () => {
    if (criteria.value != "") {
        populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        populateDatatable(rows.value, page.value);
    }
};

const onSort = (e) => {
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, criteria.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable(e.rows, e.page + 1, criteria.value);
};

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
    showSpinner();
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchPaginatedCategories(
        itemsPerPage,
        page,
        uuidRouteParam.value,
        criteria,
        sort
    );
    totalRecords.value = totalRecordsDt.value;
    loading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
};

const checkArchiveCategory = (category) => {
    if (category.hasChildren) {
        swal.warning(
            "Vous ne pouvez pas archiver cette " +
            categoryLabel.value +
            " car ses sous-catégories ne sont pas archivées"
        );
    } else {
        swal
            .confirm(
                "Êtes-vous sûr de vouloir archiver cette " + categoryLabel.value + " ?"
            )
            .then((result) => {
                if (result.isConfirmed) {
                    archiveCategory(category.uuid);
                }
            });
    }
};

const archiveCategory = async (uuidCategory) => {
    await ApiService.patchWithoutSlug("categories/" + uuidCategory, { archived: true })
        .then(() => {
            swal
                .info("Cette " + categoryLabel.value + " a bien été archivée.")
                .then(() => {
                    tableData.value = tableData.value.filter(
                        (item) => item.uuid !== uuidCategory
                    );
                    let cpt = 1;
                    tableData.value.map((item) => (item.position = cpt++));
                });
        })
        .catch(() => {
            swal.error();
            return false;
        });
};

const changePositionCategory = async (e) => {
    let dragIndex = e.dragIndex;
    let dropIndex = parseInt(e.dropIndex) + (currentPage.value * rows.value);
    let uuidCategory = tableData.value[dragIndex].uuid;
    showSpinner();
    await ApiService.patchWithoutSlug("categories/" + uuidCategory, {
        position: dropIndex,
    })
        .then(() => {
            swal
                .info(`Les ${categoryLabel.value}s ont bien changé de position dans le mégamenu !`)
                .then(async () => {
                  await populateDatatable(rows.value, page.value);
                });
        })
        .catch(() => {
            swal.error();
            return false;
        });
    hideSpinner();
};

const onRowReorder = (e) => {
    if (criteria.value != "" || modeSortable.value) {
        swal.error(`Vous devez retirer les filtres afin de pouvoir modifier les positions des ${categoryLabel.value} s`);
        return false;
    }
    swal
        .confirm(`Souhaitez-vous changer l'ordre des ${categoryLabel.value} s dans le mégamenu ?`)
        .then((result) => {
            if (result.isConfirmed) {
                changePositionCategory(e);
            }
        });
};

const showSpinner = () => {
    loading.value = true;
}

const hideSpinner = () => {
    loading.value = false;
}
</script>
